import o from "./highrise221.mjs";
/* empty css             */
import t from "./highrise181.mjs";
const c = /* @__PURE__ */ t(o, [["__scopeId", "data-v-fc924888"]]);
export {
  c as default
};
